module.exports = __webpack_public_path__ + "img/text_large.5fd9acaa.webp";